module.exports = __webpack_public_path__ + "img/punto-limpio.4b4d9ad2.svg";